import { useState, useMemo } from 'react';
import { Checkbox, Col, Row, message } from 'antd';

type props = {
  datas: any;
  checkCallback1: (params: { isChecked?: boolean; code: string; id: string }) => void;
  checkCallback2: (list: any) => void;
};
const Permissions = (props: props) => {
  const { datas, checkCallback1, checkCallback2 } = props;
  const [checkAll, setCheckAll] = useState(datas.status == 1);
  const [isShowOptions, setIsShowOptions] = useState(datas?.children?.length > 0 ? 20 : 0);
  const [checkedList, setCheckedList] = useState<any[]>(
    datas?.children?.filter((d: any) => d.status == '1')?.map((d: any) => d?.id) || [],
  );

  const onAssetChange = (e: any) => {
    const isChecked = e.target.checked;
    setCheckedList(isChecked ? plainOptions?.map((p: any) => p.id) : []);
    setIsShowOptions(isChecked && datas?.children?.length > 0 ? 20 : 0);
    setCheckAll(isChecked);
    checkCallback1({ isChecked, code: datas.code, id: datas.id });
  };

  const onOptionChange = (list: any) => {
    if (checkedList.length === 1 && list.length === 0) {
      message.warning('至少勾选一个应用');
    } else {
      setCheckedList(list);
      setCheckAll(list.length === plainOptions.length);
      checkCallback2(list);
    }
  };

  const plainOptions = useMemo(() => {
    return (
      datas?.children?.map((c: any) => {
        return {
          ...c,
          label: c?.name,
          value: c?.id,
        };
      }) || []
    );
  }, [datas]);

  return (
    <Row style={{ marginTop: '18px' }}>
      <Col span={4}>
        <div style={{ lineHeight: 2.3 }}>
          <Checkbox
            indeterminate={checkedList.length > 0 && datas?.children?.length > checkedList.length}
            onChange={onAssetChange}
            checked={checkAll}
          >
            {datas?.name}
          </Checkbox>
        </div>
      </Col>
      <Col span={isShowOptions}>
        <div
          style={{
            width: 612,
            backgroundColor: '#f2f3f5',
            padding: '4px 0 4px 16px',
          }}
        >
          <Checkbox.Group onChange={onOptionChange} value={checkedList} options={plainOptions} />
        </div>
      </Col>
    </Row>
  );
};

export default Permissions;
